export default "__VITE_ASSET__BoInJuBx__"